import React, {useEffect, useRef, useState} from 'react';
import {Toast} from "primereact/toast";
import {ContainerTitleTable} from "../../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../../components/Containers/ContainerTable";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {UsePermissions} from "../../../hooks/usePermissions";
import {UseLoader} from "../../../hooks/useLoader";
import {convertirModena, error} from "../../../shared/utils/utils";
import {confirmDialog} from "primereact/confirmdialog";
import {aplicarCuotaDeta, editarCuotaDeta} from "../../../api/liquidacionDeduccion.service";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import NumberFormat from "react-number-format";

import './liquidacionDeduccion.scss'

export const TableDeduccionesTotal = ({deducciones, obtenerParametros, asociado, liquidacionId, reload, disponible, aplicarCuota, editarCuota, cleanParams}) => {
    const [permisos] = UsePermissions()
    const [handleLoad] = UseLoader();
    const toast = useRef(null);
    const [expandedRows, setExpandedRows] = useState(null);
    const [show, setShow] = useState(false);
    const params = {
        deduccioncxc_id: '',
        deduccioncxcdet_id: '',
        estado: "",
        valor_cuota: '',
        num_cuota: ''
    }

    const [field, setField] = useState(params);


    useEffect(() => {
        if (cleanParams) {
            setField(params) ;
            setShow(false);
        }
    }, [cleanParams]);

    const valorPagoBodyTemplate = (rowData) => {
        return convertirModena(rowData.valor_diferido);
    }
    const valorPagoAboBodyTemplate = (rowData) => {
        return convertirModena(rowData.valor_abonado);
    }

    const valorCuotaBodyTemplate = (rowData) => {
        return convertirModena(rowData.valor_cuota);
    }

    const valorEstadiBodyTemplate = (rowData) => {
        if (rowData.estado === 'P') {
            return "Pagada"
        }
        return "Causada"

    }


    const editar = (e) => {
        e.preventDefault();
        editarCuota(field)
    }

    const header = (
        <div className="flex align-items-center justify-between ">
            <p className="p-2  text-sm"> Total registros: {deducciones.length}</p>
            {show && <form onSubmit={editar}>
                <div className={"row"}>
                    <ContainerGroupForm width="lg:w-6/12">
                        <label
                            className="label-form"
                            htmlFor="valor"
                        >
                            Nuevo valor *
                        </label>
                        <NumberFormat
                            id="valor"
                            thousandsGroupStyle="thousand"
                            value={field.valor_cuota}
                            prefix="$"
                            displayType="input"
                            type="text"
                            decimalSeparator="."
                            className="form-input-small"
                            thousandSeparator={true}
                            allowNegative={true}
                            onValueChange={(e) => setField({...field, valor_cuota: e.value})}
                        />

                        {error(field.valor_cuota, 'required')}


                    </ContainerGroupForm>
                    <ContainerGroupForm width="lg:w-4/12">

                        <button
                            className="primary-color-btn btn w-full mt-5"
                            type="submit"
                        >
                            Aplicar
                        </button>

                    </ContainerGroupForm>
                </div>
            </form>}
        </div>
    );

    const actionTemplate = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">

                <button
                    disabled={(!permisos.editar)}
                    className="btn primary-color-btn"
                    type="button"
                    onClick={() => obtenerParametros(rowData)}>
                    <i className="fa fa-user-edit"/>
                </button>
            </div>
        );
    }

    const actionTemplateApply = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">

                <button
                    disabled={(!permisos.adicionar)}
                    className="btn secundary-color-btn"
                    type="button"
                    onClick={() => aplicarCuota(rowData)}>
                    <i className="fa fa-money-bill"/>
                </button>
                <button
                    disabled={(!permisos.adicionar)}
                    className="btn warning-color-btn"
                    type="button"
                    onClick={() => mostrarNuevovalor(rowData)}>
                    <i className="fa fa-credit-card"/>
                </button>
            </div>
        );
    }

    const rowExpansionTemplate = (data) => {
        return (
            <div className="orders-subtable">

                <DataTable showGridlines rowClassName={rowClass} value={data.detalle} responsiveLayout="scroll">
                    <Column header="Aplicar" style={{fontSize: ".8em"}} body={actionTemplateApply}></Column>
                    {/*<Column field="deduccioncxcdet_id" header="Id" sortable></Column>*/}
                    <Column field="num_cuota" header="Cuota" filter sortable></Column>
                    <Column field="valor_cuota" filter header="Valor Cuota" body={valorCuotaBodyTemplate}
                            sortable></Column>
                    <Column field="estado" header="Estado" body={valorEstadiBodyTemplate} filter sortable></Column>
                    <Column field="anio" header="Año" filter sortable></Column>
                    <Column field="mes" header="mes" filter sortable></Column>

                </DataTable>
            </div>
        );
    }



    const mostrarNuevovalor = (data) => {

        if (data.estado !== 'C' ) {
            toast.current?.show({
                severity: 'error',
                summary: 'Alerta',
                detail: 'La cuota ya se encuentra pagada',
                life: 3000
            });
            return;
        }
        setShow(true);
        setField({...field, valor_cuota:data.valor_cuota, estado: data.estado, deduccioncxc_id: data.deduccioncxc_id,
        deduccioncxcdet_id: data.deduccioncxcdet_id, num_cuota: data.num_cuota})

    }

    const rowClass = (data) => {
        return {
            'row-pagada': data.estado === 'P'
        }
    }

    const rowClassEnc = (data) => {
        return {
            'row-pagada-enc': data.pagada === 'S'
        }
    }
    return (
        <>
            <Toast ref={toast}/>
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>

            <ContainerTable>
                <DataTable
                    resizableColumns
                    columnResizeMode="expand"
                    header={header}
                    size="small"
                    showGridlines
                    value={deducciones}
                    scrollable
                    scrollHeight="400px"
                    rowClassName={rowClassEnc}
                    rowExpansionTemplate={rowExpansionTemplate}
                    expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}

                    responsiveLayout="scroll">

                    <Column expander style={{width: '3em'}}/>
                    {/*  <Column field="deduccioncxc_id" header="Id"
                    ></Column>*/}
                    <Column header="Editar" style={{fontSize: ".8em"}} body={actionTemplate}></Column>
                    <Column field="descripcion"  sortable filter header="Concepto"
                    ></Column>
                    <Column field="descrip_abrev" header="Fondo"
                    ></Column>

                    <Column field="tercero" header="Tercero"
                    ></Column>
                    <Column field="cant_cuotas" header="Cuotas"
                    ></Column>

                    <Column field="valor_diferido" header="Valor" body={valorPagoBodyTemplate}
                            showFilterMatchModes={false}
                    >
                    </Column>
                    <Column field="valor_abonado" header="Valor abonado" body={valorPagoAboBodyTemplate}
                            showFilterMatchModes={false}
                    >
                    </Column>
                    <Column field="num_egreso" header="Egreso"
                    ></Column>

                </DataTable>
            </ContainerTable>


        </>
    );
};

TableDeduccionesTotal.defaultProps = {
    cleanParams: false
}
